/**
 * @ Author: Housefolios
 * @ Create Time: 2023-11-03 14:37:55
 * @ Modified by: David Helmick
 * @ Modified time: 2025-04-22 15:06:33
 * @ Description: Checks if awaitingRealeflowProperties boolean is true. If it is it sets it to false and refetches properties
 */

import React, { useEffect, useState } from 'react'

// Centralized lodash imports - much cleaner!
import {
  head,
  map,
  isEmpty,
  includes,
  find,
  orderBy,
} from '@/utils/lodash'
import { zip, strToU8 } from 'fflate'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  useLazyQuery,
  useMutation,
  useQuery,
  useSubscription,
} from '@apollo/client/react'
import { GET_PORTFOLIOS } from '@/housefolios-components/Portfolio/queries'
import {
  GET_AWAITING_REALEFLOW_PROPERTIES,
  GET_UNPROCESSED_PROPERTY_LEADS,
  GET_BATCH_AGENT_MATCHES,
} from './queries'
import { UPDATE_ORGANIZATION } from '@/housefolios-components/OrganizationSettings/mutations'
import { GET_ME } from '@/housefolios-components/Session/queries'
import {
  GET_PROPERTIES,
  GET_TRASH,
} from '@/housefolios-components/Properties/queries'
import { DELETE_PROPERTIES } from '@/housefolios-components/Properties/mutation'
import {
  Badge,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Box,
} from '@mui/material'
import {
  FolderOpenOutlined,
  Close as CloseIcon,
} from '@mui/icons-material'
import BlockUi from 'react-block-ui'
import { PacmanLoader } from 'react-spinners'
import { GET_PROPERTIES_QUERY_LIMIT } from '@/utils/pagination'
import useImportRealeflowLeadsSubscription from '@/hooks/useImportRealeflowLeadsSubscription'
import { closeSnackbar, useSnackbar } from 'notistack'
import {
  LEADS_NOTIFICATION,
  NEW_REALEFLOW_IMPORT_SUBSCRIPTION,
} from './subscription'
import CreatePortfolio from '../Portfolio/CreatePortfolio'
import withSession from '../Session/withSession'
import { DELETE_BATCH, IMPORT_LEADS } from './mutation'
import { Stack } from '@mui/material'
import { height } from '@mui/system'
import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark'
import {
  GET_COMMERCIAL_PORTFOLIOS,
  GET_COMMERCIAL_PROPERTIES,
} from '../Lots/queries'

function RealeflowProperties(props) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const [updating, setUpdating] = useState(false)

  const [selectedPortfolio, setSelectedPortfolio] = useState(
    props.portfolioId !== 'null' && props.portfolioId
      ? props.portfolioId
      : head(props.portfolios)?._id,
  )
  const [selectedBatch, setSelectedBatch] = useState(null)
  const [openPortfolio, setOpenPortfolio] = useState(false)
  const [openBatch, setOpenBatch] = useState(false)
  const [openDuplicates, setOpenDuplicates] = useState(false)
  const [openDownloadAgent, setOpenDownloadAgent] = useState(false)
  const [downloadAgentData, setDownloadAgentData] = useState('No')

  const handleOpenPortfolio = () => {
    setOpenPortfolio(true)
  }
  const handleClosePortfolio = () => {
    setOpenPortfolio(false)
  }

  const handleOpenBatch = () => {
    setOpenBatch(true)
  }
  const handleCloseBatch = () => {
    setOpenBatch(false)
  }

  const handleOpenDuplicates = () => {
    setOpenDuplicates(true)
  }
  const handleCloseDuplicates = () => {
    setOpenDuplicates(false)
  }

  const handleOpenDownloadAgent = () => {
    setOpenDownloadAgent(true)
  }
  const handleCloseDownloadAgent = () => {
    setOpenDownloadAgent(false)
  }

  const [confirm, setConfirm] = useState('true')
  const [loaderSnackKey, setLoaderSnackKey] = useState('dummyKey')

  const [newLead, setNewLead] = useState(false)

  let results = useQuery(GET_PORTFOLIOS)
  const { portfolios } = results.data || {}
  // console.log(portfolios)

  results = useQuery(GET_COMMERCIAL_PORTFOLIOS)
  const { commercialPortfolios } = results.data || {}

  const {
    loading: loadingUnprocessedLeads,
    data: unprocessedLeads,
    error: unprocessedLeadsError,
    refetch: unprocessedLeadsRefetch,
  } = useQuery(GET_UNPROCESSED_PROPERTY_LEADS, {
    variables: {
      orgId: props.session.me.activeOrg._id,
    },
    // pollInterval: 1 * 60 * 1000,
    // pollInterval: updating ? 0 : 15 * 60 * 1000,
    // skip: updating,
  })
  const [
    importLeads,
    { loading: loadingImportLeads, error: importLeadsError },
  ] = useMutation(IMPORT_LEADS)

  const [getBatchAgentMatches, { loading: loadingAgentMatches }] =
    useLazyQuery(GET_BATCH_AGENT_MATCHES, {
      fetchPolicy: 'network-only',
    })

  const [
    deleteBatch,
    // { loading: loadingImportLeads, error: importLeadsError },
  ] = useMutation(DELETE_BATCH)

  const {
    loading: _,
    data: leadsNotificationData,
    error: leadsNoficationError,
  } = useSubscription(LEADS_NOTIFICATION, {
    variables: {
      orgId: props.session.me.activeOrg._id,
      userId: props.session.me._id,
    },
    // onData: (data) => {
    //   console.log('leads notification', data)
    // },
    // onComplete: () => {
    //   console.log('first')
    // },
  })

  // useEffect(() => {
  //   if (
  //     !loadingUnprocessedLeads &&
  //     unprocessedLeads?.getUnproccessedLeadsBatch?.success &&
  //     !isEmpty(unprocessedLeads?.getUnproccessedLeadsBatch?.batches)
  //   ) {
  //     setUpdating(true)
  //     setNewLead(false)
  //   }
  // }, [loadingUnprocessedLeads])

  const { loading, data, error } = useSubscription(
    NEW_REALEFLOW_IMPORT_SUBSCRIPTION,
    {
      variables: {
        orgId: props.session.me.activeOrg._id,
      },
    },
  )
  const { newLeadsFromRealeflow = {} } = data || {}

  const handleSubmit = () => {
    if (!selectedPortfolio) {
      enqueueSnackbar(
        'Choose a portfolio from the list',
        // leadsNotificationData?.getNewLeadsNotification.message,
        {
          variant: 'error',
          // autoHideDuration: null,
          anchorOrigin: { horizontal: 'center', vertical: 'top' },
          action: (key) => (
            <>
              <IconButton
                onClick={() => closeSnackbar(key)}
                size="large"
              >
                <CloseIcon style={{ color: 'white' }} />
              </IconButton>
            </>
          ),
          // preventDuplicate: true,
        },
      )
    } else if (!selectedBatch) {
      enqueueSnackbar(
        'Choose a batch from the list',
        // leadsNotificationData?.getNewLeadsNotification.message,
        {
          variant: 'error',
          // autoHideDuration: null,
          anchorOrigin: { horizontal: 'center', vertical: 'top' },
          action: (key) => (
            <>
              <IconButton
                onClick={() => closeSnackbar(key)}
                size="large"
              >
                <CloseIcon style={{ color: 'white' }} />
              </IconButton>
            </>
          ),
          // preventDuplicate: true,
        },
      )
    } else {
      // If downloadAgentData is "Yes", fetch and download agent matches first
      if (downloadAgentData === 'Yes' && selectedPortfolio) {
        getBatchAgentMatches({
          variables: {
            batchId: selectedBatch,
            orgId: props.session.me.activeOrg._id,
          },
        })
          .then((result) => {
            const payload = result?.data?.getBatchAgentMatches
            if (!payload) return

            // If there are no agent matches AND no office-only matches, skip download and show message.
            if (
              (!payload.agentMatchCount ||
                payload.agentMatchCount <= 0) &&
              (!payload.officeMatchCount ||
                payload.officeMatchCount <= 0)
            ) {
              enqueueSnackbar(
                payload.agentInfoCount > 0
                  ? 'No agent matches were found for any of the leads.'
                  : 'No agent info was found for any of the leads.',
                {
                  variant: 'info',
                  persist: true,
                  anchorOrigin: {
                    horizontal: 'right',
                    vertical: 'top',
                  },
                  action: (key) => (
                    <IconButton
                      onClick={() => closeSnackbar(key)}
                      size="large"
                    >
                      <CloseIcon style={{ color: 'white' }} />
                    </IconButton>
                  ),
                },
              )
              return
            }

            // Create ZIP file containing CSV
            const baseFilename =
              payload.filename || `agent-data-${selectedBatch}.csv`
            const csvFilename = baseFilename.endsWith('.csv')
              ? baseFilename
              : `${baseFilename}.csv`
            const zipFilename = baseFilename.endsWith('.csv')
              ? baseFilename.replace('.csv', '.zip')
              : `${baseFilename}.zip`

            const csvData = payload.csvData || ''
            const csvBytes = strToU8(csvData)

            zip(
              { [csvFilename]: csvBytes },
              { level: 6 },
              (err, zipData) => {
                if (err) {
                  console.error('Error creating ZIP file:', err)
                  enqueueSnackbar('Failed to create ZIP file', {
                    variant: 'error',
                    persist: true,
                    anchorOrigin: {
                      horizontal: 'right',
                      vertical: 'top',
                    },
                    action: (key) => (
                      <IconButton
                        onClick={() => closeSnackbar(key)}
                        size="large"
                      >
                        <CloseIcon style={{ color: 'white' }} />
                      </IconButton>
                    ),
                  })
                  return
                }

                const blob = new Blob([zipData], {
                  type: 'application/zip',
                })
                const link = document.createElement('a')
                const url = URL.createObjectURL(blob)
                link.setAttribute('href', url)
                link.setAttribute('download', zipFilename)
                link.style.visibility = 'hidden'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                URL.revokeObjectURL(url)
              },
            )
          })
          .catch((error) => {
            console.error('Error downloading agent matches:', error)
            enqueueSnackbar('Failed to download agent data', {
              variant: 'error',
              persist: true,
              anchorOrigin: { horizontal: 'right', vertical: 'top' },
              action: (key) => (
                <IconButton
                  onClick={() => closeSnackbar(key)}
                  size="large"
                >
                  <CloseIcon style={{ color: 'white' }} />
                </IconButton>
              ),
            })
          })
      }

      importLeads({
        variables: {
          batchId: selectedBatch,
          orgId: props.session.me.activeOrg._id,
          portfolioId: selectedPortfolio,
          importDuplicates: confirm === 'true',
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: GET_ME,
          },
          {
            query: GET_PORTFOLIOS,
          },
          {
            query: GET_COMMERCIAL_PORTFOLIOS,
          },
          {
            query: GET_COMMERCIAL_PROPERTIES,
            variables: {
              portfolioId: [selectedPortfolio],
              // limit: GET_PROPERTIES_QUERY_LIMIT,
            },
          },
          {
            query: GET_COMMERCIAL_PROPERTIES,
            variables: {
              portfolioId: map(
                commercialPortfolios,
                (portfolio) => portfolio?._id,
              ),
              // limit: GET_PROPERTIES_QUERY_LIMIT,
            },
          },
          {
            query: GET_PROPERTIES,
            variables: {
              portfolioId: [selectedPortfolio],
              limit: GET_PROPERTIES_QUERY_LIMIT,
            },
          },
          {
            query: GET_PROPERTIES,
            variables: {
              portfolioId: map(
                portfolios,
                (portfolio) => portfolio?._id,
              ),
              limit: GET_PROPERTIES_QUERY_LIMIT,
            },
          },
          {
            query: GET_AWAITING_REALEFLOW_PROPERTIES,
          },
          {
            query: GET_UNPROCESSED_PROPERTY_LEADS,
            variables: { orgId: props.session.me.activeOrg._id },
          },
        ],
      }).finally(() => {
        unprocessedLeadsRefetch()
      })
      setUpdating(false)
      setSelectedBatch(null)
    }
  }

  const handleDeleteBatch = () => {
    if (!selectedBatch) {
      enqueueSnackbar(
        'Choose a batch from the list',
        // leadsNotificationData?.getNewLeadsNotification.message,
        {
          variant: 'error',
          // autoHideDuration: null,
          anchorOrigin: { horizontal: 'center', vertical: 'top' },
          action: (key) => (
            <>
              <IconButton
                onClick={() => closeSnackbar(key)}
                size="large"
              >
                <CloseIcon style={{ color: 'white' }} />
              </IconButton>
            </>
          ),
          // preventDuplicate: true,
        },
      )
    } else {
      deleteBatch({
        variables: {
          batchId: selectedBatch,
          orgId: props.session.me.activeOrg._id,
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: GET_ME,
          },
          {
            query: GET_AWAITING_REALEFLOW_PROPERTIES,
          },
          {
            query: GET_UNPROCESSED_PROPERTY_LEADS,
            variables: { orgId: props.session.me.activeOrg._id },
          },
        ],
      })
      setSelectedBatch(null)
    }
  }

  // useEffect(() => {
  //   // console.log('new leads', newLeadsFromRealeflow)
  //   if (newLeadsFromRealeflow?.awaitingRealeflow && !updating) {
  //     const newRealeflowDuplicated =
  //       newLeadsFromRealeflow.duplicateProperties

  //     setUpdating(true)
  //     setNewLead(false)
  //     setConfirm('false')
  //     if (!isEmpty(newRealeflowDuplicated)) {
  //       // setSelectedProperties(newRealeflow.duplicateProperties)
  //     } else {
  //       handleSubmit()
  //     }
  //   }
  // }, [newLeadsFromRealeflow])

  useEffect(() => {
    if (leadsNotificationData) {
      if (
        leadsNotificationData?.getNewLeadsNotification.notificationType?.toLowerCase() ===
        'info'
      ) {
        unprocessedLeadsRefetch().then(({ data  }) => {
          const batches = orderBy(
            data?.getUnproccessedLeadsBatch?.batches,
            ['createdAt'],
            ['desc'],
          )
          const firstBatch = head(batches)
          // Only show popup if there are leads in the batch
          if (
            firstBatch &&
            firstBatch.leads &&
            firstBatch.leads.length > 0
          ) {
            setNewLead(true)
            if (!updating) {
              setUpdating(true)
              setSelectedBatch(firstBatch._id)
            }
          }
        })
        // setConfirm('false')
      } else {
        enqueueSnackbar(
          leadsNotificationData?.getNewLeadsNotification.message,
          {
            variant:
              leadsNotificationData?.getNewLeadsNotification.notificationType?.toLowerCase(),
            autoHideDuration: null,
            anchorOrigin: { horizontal: 'right', vertical: 'top' },
            action: (key) => (
              <>
                <IconButton
                  onClick={() => closeSnackbar(key)}
                  size="large"
                >
                  <CloseIcon style={{ color: 'white' }} />
                </IconButton>
              </>
            ),
            // preventDuplicate: true,
          },
        )

        if (
          includes(
            leadsNotificationData?.getNewLeadsNotification.message,
            'properties successfully',
          ) &&
          !includes(
            leadsNotificationData?.getNewLeadsNotification.message,
            'Processed comps for 0 properties successfully',
          ) &&
          !includes(
            leadsNotificationData?.getNewLeadsNotification.message,
            '0 properties successfully',
          ) &&
          !includes(
            leadsNotificationData?.getNewLeadsNotification.message,
            '0 investors successfully',
          ) &&
          !includes(
            leadsNotificationData?.getNewLeadsNotification.message,
            '0 commercial properties successfully',
          )
        ) {
          closeSnackbar(loaderSnackKey)
          let key = enqueueSnackbar(
            <Stack
              direction="row"
              spacing={2}
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress color="inherit" size={25} />{' '}
              <span> Importing comps</span>
            </Stack>,
            {
              autoHideDuration: null,
              // anchorOrigin: { horizontal: 'right', vertical: 'top' },
              action: (key) => (
                <>
                  <IconButton
                    onClick={() => closeSnackbar(key)}
                    size="large"
                  >
                    <CloseIcon style={{ color: 'white' }} />
                  </IconButton>
                  {!loadingImportLeads && closeSnackbar(key)}
                </>
              ),
              preventDuplicate: true,
            },
          )
          setLoaderSnackKey(key)
        }
      }
    }

    // if(unprocessedLeads?.getUnproccessedLeadsBatch?.success){
    //   enqueueSnackbar(
    //   ""
    //     {
    //       variant:
    //       ,
    //       autoHideDuration: null,
    //       anchorOrigin: { horizontal: 'right', vertical: 'top' },
    //       action: (key) => (
    //         <>
    //           <IconButton onClick={() => closeSnackbar(key)}>
    //             <CloseIcon style={{ color: 'white' }} />
    //           </IconButton>
    //         </>
    //       ),
    //       // preventDuplicate: true,
    //     },
    //   )
    // }
  }, [leadsNotificationData])

  useEffect(() => {
    if (loadingImportLeads) {
      let key = enqueueSnackbar(
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress color="inherit" size={25} />{' '}
          <span> Importing leads</span>
        </Stack>,
        {
          autoHideDuration: null,
          // anchorOrigin: { horizontal: 'right', vertical: 'top' },
          action: (key) => (
            <>
              <IconButton
                onClick={() => closeSnackbar(key)}
                size="large"
              >
                <CloseIcon style={{ color: 'white' }} />
              </IconButton>
              {!loadingImportLeads && closeSnackbar(key)}
            </>
          ),
          preventDuplicate: true,
        },
      )
      setLoaderSnackKey(key)
    } else closeSnackbar(loaderSnackKey)
  }, [loadingImportLeads])

  const dateImported = leadsNotificationData?.getNewLeadsNotification
    .dateImported
    ? new Date(
        Number(
          leadsNotificationData?.getNewLeadsNotification.dateImported,
        ),
      ).toLocaleString()
    : 'N/A'

  const parseDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleString()
  }

  const displayedBatch = find(
    unprocessedLeads?.getUnproccessedLeadsBatch?.batches,
    (batch) => {
      return batch?._id === selectedBatch
    },
  )

  useEffect(() => {
    setSelectedPortfolio(
      props.portfolioId !== 'null' && props.portfolioId
        ? props.portfolioId
        : head(portfolios)?._id,
    )
  }, [displayedBatch?.productType])

  useEffect(() => {
    const batches =
      unprocessedLeads?.getUnproccessedLeadsBatch?.batches || []
    if (batches.length === 0) {
      setNewLead(false)
    }
  }, [unprocessedLeads])

  // console.log(dateImported)
  // console.log(props.session.me)
  return (
    <>
      <IconButton
        onClick={() => {
          setUpdating(true)
          setNewLead(false)
          setConfirm('true')
        }}
        size="large"
      >
        <Badge variant="dot" invisible={!newLead} color="error">
          <CollectionsBookmarkIcon />
        </Badge>
      </IconButton>

      <Dialog
        // open={updating && !isEmpty(duplicateProperties)}
        open={updating}
        maxWidth="sm"
        fullWidth={true}
        onClose={() => {
          setUpdating(false)
          setSelectedBatch(null)
        }}
      >
        <DialogTitle>Leads to Portfolio</DialogTitle>
        <Box sx={{ textAlign: 'center', p: '3rem' }}>
          <Grid size={12}>
            <FormControl
              variant="outlined"
              margin="dense"
              style={{ width: '100%' }}
            >
              <InputLabel id="demo-simple-select-label">
                Select Batch
              </InputLabel>
              <Select
                variant="outlined"
                margin="dense"
                fullWidth
                //id=""
                label="Select Batch"
                value={selectedBatch}
                onChange={(event) =>
                  setSelectedBatch(event.target.value)
                }
                open={openBatch}
                onOpen={handleOpenBatch}
                onClose={handleCloseBatch}
                MenuProps={{ keepMounted: true }}
                // InputProps={{
                //   startAdornment: (
                //     <InputAdornment position="start">
                //       <FolderOpenOutlined />
                //     </InputAdornment>
                //   ),
                //   endAdornment: (
                //     <InputAdornment position="end"></InputAdornment>
                //   ),
                // }}
                // disabled={props?.session?.me?.activeOrg?.member === 'RWN'}
              >
                {map(
                  orderBy(
                    unprocessedLeads?.getUnproccessedLeadsBatch
                      ?.batches,
                    ['createdAt'],
                    ['desc'],
                  ),
                  (batch) => (
                    <MenuItem key={batch._id} value={batch._id}>
                      {`${batch.productType === 'People' ? 'Investor' : batch.productType || 'Residential'} - ${parseDate(batch?.createdAt)}`}
                    </MenuItem>
                  ),
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={12} style={{ marginTop: 15 }}>
            <h6>My Leads</h6>
          </Grid>
          <Grid
            style={{
              height: 300,
              border: '1px solid grey',
              overflow: 'scroll',
            }}
          >
            {map(
              (displayedBatch?.leads || []).filter(Boolean),
              (lead, idx) => {
                if (displayedBatch?.productType === 'People') {
                  // For investor/people leads
                  const name = lead.FullName || ''
                  const city = lead.MailingAddressCity || ''
                  const state = lead.MailingAddressState || ''
                  const addr = `${name} - ${city}, ${state}`
                  return (
                    <Typography key={lead.MailingAddressHash || idx}>
                      {addr}
                    </Typography>
                  )
                } else {
                  // For property leads
                  const leadProperty = lead?.SubjectProperty || lead
                  const {
                    PropertyAddress = leadProperty.Address, // Fallback to Address
                    PropertyCity = leadProperty.City, // Fallback to City
                    PropertyState = leadProperty.State, // Fallback to State
                    PropertyPostalCode = leadProperty.ZipCode, // Fallback to ZipCode
                  } = {
                    PropertyAddress:
                      leadProperty.PropertyAddress ||
                      leadProperty.Address,
                    PropertyCity:
                      leadProperty.PropertyCity || leadProperty.City,
                    PropertyState:
                      leadProperty.PropertyState ||
                      leadProperty.State,
                    PropertyPostalCode:
                      leadProperty.PropertyPostalCode ||
                      leadProperty.ZipCode,
                  }

                  const addr = `${PropertyAddress} ${PropertyCity}, ${PropertyState} ${PropertyPostalCode}`
                  return (
                    <Typography key={leadProperty.AddressHash || idx}>
                      {addr}
                    </Typography>
                  )
                }
              },
            )}
          </Grid>
          <Grid size={12} style={{ marginTop: 15 }}>
            <h6>
              In which portfolio do we save the{' '}
              {displayedBatch?.leads?.length || ''} leads
            </h6>
          </Grid>
          <Grid size={12}>
            <FormControl
              variant="outlined"
              margin="dense"
              style={{ width: '100%' }}
            >
              <InputLabel id="demo-simple-select-label">
                Select Portfolio
              </InputLabel>
              <Select
                variant="outlined"
                margin="dense"
                fullWidth
                //id=""
                select
                label="Select Portfolio"
                value={selectedPortfolio}
                onChange={(event) =>
                  setSelectedPortfolio(event.target.value)
                }
                open={openPortfolio}
                onOpen={handleOpenPortfolio}
                onClose={handleClosePortfolio}
                MenuProps={{ keepMounted: true }}
                startAdornment={
                  <InputAdornment position="start">
                    <FolderOpenOutlined />
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end"></InputAdornment>
                }
                // disabled={props?.session?.me?.activeOrg?.member === 'RWN'}
              >
                {props?.session?.me?.activeOrg?.member === 'RWN' && (
                  <MenuItem
                    key="My Properties"
                    value={portfolios ? portfolios[0]._id : null}
                  >
                    My Properties
                  </MenuItem>
                )}
                {props?.session?.me?.activeOrg?.member !== 'RWN' &&
                  map(portfolios, (option) => (
                    <MenuItem key={option._id} value={option._id}>
                      {option.name}
                    </MenuItem>
                  ))}
                {props?.session?.me?.activeOrg?.member !== 'RWN' && (
                  <CreatePortfolio
                    dropdown={true}
                    setNewPortfolio={setSelectedPortfolio}
                    closeMenu={handleClosePortfolio}
                  />
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={12} style={{ marginTop: 15 }}>
            <h6>If you have one of these leads already:</h6>
          </Grid>
          <Grid size={12}>
            <FormControl
              variant="outlined"
              margin="dense"
              style={{ width: '100%' }}
            >
              <InputLabel id="demo-simple-select-label">
                Duplicates
              </InputLabel>
              <Select
                variant="outlined"
                margin="dense"
                fullWidth
                label="Duplicates"
                value={confirm}
                onChange={(event) => setConfirm(event.target.value)}
                open={openDuplicates}
                onOpen={handleOpenDuplicates}
                onClose={handleCloseDuplicates}
                MenuProps={{ keepMounted: true }}
                // disabled={props?.session?.me?.activeOrg?.member === 'RWN'}
              >
                <MenuItem key="Save Duplicates" value={'true'}>
                  Save Duplicates
                </MenuItem>
                <MenuItem key="Skip Duplicates" value={'false'}>
                  Skip Duplicates
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <>
            <Grid size={12} style={{ marginTop: 15 }}>
              <h6>Download Agent Data</h6>
            </Grid>
            <Grid size={12}>
              <FormControl
                variant="outlined"
                margin="dense"
                style={{ width: '100%' }}
              >
                <InputLabel id="download-agent-select-label">
                  Download Agent Data
                </InputLabel>
                <Select
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  label="Download Agent Data"
                  value={downloadAgentData}
                  onChange={(event) =>
                    setDownloadAgentData(event.target.value)
                  }
                  open={openDownloadAgent}
                  onOpen={handleOpenDownloadAgent}
                  onClose={handleCloseDownloadAgent}
                  MenuProps={{ keepMounted: true }}
                >
                  <MenuItem key="No" value={'No'}>
                    No
                  </MenuItem>
                  <MenuItem key="Yes" value={'Yes'}>
                    Yes
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </>
          <DialogActions>
            <Button
              variant="contained"
              color="error"
              onClick={() => handleDeleteBatch()}
            >
              <Box component="span" sx={{
                display: "inline-block",
                "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
              }}>Delete</Box>
            </Button>
            <Button
              variant="text"
              onClick={() => {
                setUpdating(false)
                setSelectedBatch(null)
                setDownloadAgentData('No')
              }}
            >
              <Box component="span" sx={{
                display: "inline-block",
                "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
              }}>Cancel</Box>
            </Button>
            <Button
              variant="contained"
              color="primary"
              // style={{ backgroundColor: '#f83145', color: 'white' }}
              onClick={() => handleSubmit()}
              // disabled={!confirm}
            >
              <Box component="span" sx={{
                display: "inline-block",
                "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
              }}>Save</Box>
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  )
}

export default withSession(RealeflowProperties)
